import { v4 as uuidv4 } from 'uuid';

const generateFileName = (file: File) => {
  return `${uuidv4()}.${file.type?.split('/')[1] || ''}`;
};

export default generateFileName;
